import { render, staticRenderFns } from "./TreatmentConfirmTemplate.vue?vue&type=template&id=2c28e161&scoped=true&"
import script from "./TreatmentConfirmTemplate.vue?vue&type=script&lang=ts&"
export * from "./TreatmentConfirmTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./TreatmentConfirmTemplate.vue?vue&type=style&index=0&id=2c28e161&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c28e161",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
